document.addEventListener('DOMContentLoaded', function() {
  const contactForm = document.querySelector('.fixed-contact-form');
  const collapseButton = document.querySelector('.contact-form-collapse-button');
  
  if (collapseButton && contactForm) {
    // Check if form should be collapsed on page load
    if (localStorage.getItem('contact-form-collapsed') === 'true') {
      contactForm.classList.add('collapsed');
    }
    
    // Toggle collapse state when button is clicked
    collapseButton.addEventListener('click', function() {
      contactForm.classList.toggle('collapsed');
      
      // Save state to localStorage
      if (contactForm.classList.contains('collapsed')) {
        localStorage.setItem('contact-form-collapsed', 'true');
      } else {
        localStorage.setItem('contact-form-collapsed', 'false');
      }
    });
  }
});
